"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialLoader = exports.MATERIAL_TYPE = void 0;
const THREE = __importStar(require("three"));
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const PCSS_1 = require("../shaders/PCSS");
const SpecularGlossinessMaterial_1 = require("../materials/SpecularGlossinessMaterial");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const tsyringe_1 = require("tsyringe");
const EnvironmentMapLoader_1 = require("./EnvironmentMapLoader");
var MATERIAL_TYPE;
(function (MATERIAL_TYPE) {
    MATERIAL_TYPE["POINT"] = "point";
    MATERIAL_TYPE["LINE"] = "line";
    MATERIAL_TYPE["UNLIT"] = "unlit";
    MATERIAL_TYPE["SPECULAR_GLOSSINESS"] = "specular_glossiness";
    MATERIAL_TYPE["METALNESS_ROUGHNESS"] = "metalness_roughness";
})(MATERIAL_TYPE = exports.MATERIAL_TYPE || (exports.MATERIAL_TYPE = {}));
class MaterialLoader {
    // #endregion Properties (8)
    // #region Constructors (1)
    constructor(_renderingEngine) {
        this._renderingEngine = _renderingEngine;
        // #region Properties (8)
        this._converter = tsyringe_1.container.resolve(viewer_shared_services_1.Converter);
        this._defaultColor = '#00fff7';
        this._logger = tsyringe_1.container.resolve(viewer_shared_services_1.Logger);
        this._materialCache = {};
        this._blending = 0.0;
        this._envMap = null;
        this._height = 1020;
        this._lightSizeUV = 0.025;
        this._pointSize = 1.0;
        this._textureEncoding = THREE.sRGBEncoding;
        this._maxMapCount = 0;
        this._envMapType = EnvironmentMapLoader_1.ENVIRONMENT_MAP_TYPE.NONE;
        let shader = THREE.ShaderChunk.shadowmap_pars_fragment;
        if (!shader.includes('PCSS implementation')) {
            shader = shader.replace('#ifdef USE_SHADOWMAP', '#ifdef USE_SHADOWMAP' + PCSS_1.main);
            shader = shader.replace(shader.substr(shader.indexOf('#if defined( SHADOWMAP_TYPE_PCF )'), shader.indexOf('#elif defined( SHADOWMAP_TYPE_PCF_SOFT )') - shader.indexOf('#if defined( SHADOWMAP_TYPE_PCF )')), '#if defined( SHADOWMAP_TYPE_PCF )\n' + PCSS_1.entry);
        }
        THREE.ShaderChunk.shadowmap_pars_fragment = shader;
        THREE.ShaderChunk.envmap_fragment = THREE.ShaderChunk.envmap_fragment.replace(`vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );`, `
            #ifdef ENVMAP_TYPE_LDR
                vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );
            #else
                vec4 envColor = textureCubeUV( envMap, reflectVec.xzy, 0.0 );
            #endif
            `);
        THREE.ShaderChunk.envmap_physical_pars_fragment = THREE.ShaderChunk.envmap_physical_pars_fragment.replace(`vec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );`, `
            #ifdef ENVMAP_TYPE_LDR
                vec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );
            #else
                vec4 envMapColor = textureCubeLodEXT( envMap, queryVec.xzy, float( maxMIPLevel ) );
            #endif`);
        THREE.ShaderChunk.envmap_physical_pars_fragment = THREE.ShaderChunk.envmap_physical_pars_fragment.replace(`vec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );`, `
            #ifdef ENVMAP_TYPE_LDR
                vec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );
            #else
                vec4 envMapColor = textureCube( envMap, queryVec.xzy, float( maxMIPLevel ) );
            #endif`);
        THREE.ShaderChunk.envmap_physical_pars_fragment = THREE.ShaderChunk.envmap_physical_pars_fragment.replace(`vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );`, `
            #ifdef ENVMAP_TYPE_LDR
                vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
            #else
                vec4 envMapColor = textureCubeUV( envMap, worldNormal.xzy, 1.0 );
            #endif`);
        THREE.ShaderChunk.envmap_physical_pars_fragment = THREE.ShaderChunk.envmap_physical_pars_fragment.replace(`vec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );`, `
            #ifdef ENVMAP_TYPE_LDR
                vec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );
            #else
                vec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec.xzy, specularMIPLevel );
            #endif`);
        THREE.ShaderChunk.envmap_physical_pars_fragment = THREE.ShaderChunk.envmap_physical_pars_fragment.replace(`vec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );`, `
            #ifdef ENVMAP_TYPE_LDR
                vec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );
            #else
                vec4 envMapColor = textureCube( envMap, queryReflectVec.xzy, specularMIPLevel );
            #endif`);
        THREE.ShaderChunk.envmap_physical_pars_fragment = THREE.ShaderChunk.envmap_physical_pars_fragment.replace(`vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );`, `
            #ifdef ENVMAP_TYPE_LDR
                vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
            #else
                vec4 envMapColor = textureCubeUV( envMap, reflectVec.xzy, roughness );
            #endif`);
        if (!THREE.ShaderChunk.lights_fragment_maps.includes('vec3 reflectVec')) {
            var index = THREE.ShaderChunk.lights_fragment_maps.lastIndexOf('#endif');
            THREE.ShaderChunk.lights_fragment_maps = THREE.ShaderChunk.lights_fragment_maps.substring(0, index) +
                `#else
                vec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );
                reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
                radiance += (vec3((reflectVec.z + 1.0) / 2.0) + 0.5) / 1.5;
            #endif
            ` + THREE.ShaderChunk.lights_fragment_maps.substring(index + '#endif'.length);
        }
    }
    // #endregion Constructors (1)
    // #region Public Methods (7)
    assignEnvironmentMap(e, type) {
        this._envMap = e;
        this._envMapType = type;
        for (let m in this._materialCache) {
            if ((this._materialCache[m] instanceof THREE.MeshStandardMaterial || this._materialCache[m] instanceof THREE.MeshBasicMaterial)
                && !this._materialCache[m].KHR_materials_unlit) {
                this._materialCache[m].envMap = e;
                this._materialCache[m].needsUpdate = true;
                if (this._materialCache[m] instanceof THREE.MeshStandardMaterial) {
                    for (let d in this._materialCache[m].defines) {
                        if (d.startsWith('ENVMAP_TYPE_'))
                            delete this._materialCache[m].defines[d];
                    }
                    this._materialCache[m].defines['ENVMAP_TYPE_' + this._envMapType.toUpperCase()] = '';
                }
            }
        }
    }
    assignPointSize(p) {
        const height = this._renderingEngine.renderer ? this._renderingEngine.renderer.getSize(new THREE.Vector2()).y : 1080;
        if (height === this._height && p * (this._height / 1080) === this._pointSize)
            return;
        this._height = height;
        this._pointSize = p * (this._height / 1080);
        for (let m in this._materialCache) {
            if (this._materialCache[m] instanceof THREE.PointsMaterial) {
                this._materialCache[m].size = this._pointSize;
                this._materialCache[m].needsUpdate = true;
            }
        }
    }
    assignTextureEncoding() {
        for (let m in this._materialCache) {
            if (this._materialCache[m] instanceof THREE.MeshStandardMaterial) {
                if (this._materialCache[m].emissiveMap)
                    this._materialCache[m].emissiveMap.encoding = this._textureEncoding;
                if (this._materialCache[m].map)
                    this._materialCache[m].map.encoding = this._textureEncoding;
                this._materialCache[m].needsUpdate = true;
            }
        }
    }
    emptyMaterialCache() {
        this._materialCache = {};
    }
    removeFromMaterialCache(id) {
        for (let m in this._materialCache) {
            if (m.startsWith(id)) {
                delete this._materialCache[m];
            }
        }
    }
    init() { }
    getMaterialProperties(materialData, type, materialSettings) {
        const generalProperties = {};
        let mapCount = 0;
        // if no MaterialData is provided, we return our default
        if (!materialData) {
            generalProperties.color = new THREE.Color(this._converter.toThreeJsColorInput(this._defaultColor));
            if (materialSettings !== undefined && materialSettings.useVertexColors)
                generalProperties.color = new THREE.Color('#d3d3d3');
            generalProperties.side = THREE.DoubleSide;
            return { properties: generalProperties, mapCount };
        }
        /**
         * We know evaluate properties that can be applied to all materials
         */
        generalProperties.alphaTest = materialData.alphaCutoff;
        if (materialData.opacity !== undefined) {
            generalProperties.opacity = materialData.opacity;
            generalProperties.transparent = generalProperties.opacity < 1;
            generalProperties.depthWrite = !(generalProperties.opacity < 1);
        }
        if (materialData.alphaMode === viewer_shared_types_1.MATERIAL_ALPHA.BLEND) {
            generalProperties.format = THREE.RGBAFormat;
            generalProperties.transparent = true;
            generalProperties.depthWrite = false;
        }
        else if (!generalProperties.transparent) {
            generalProperties.format = THREE.RGBFormat;
            generalProperties.transparent = false;
        }
        if (materialData.color !== undefined)
            generalProperties.color = new THREE.Color(this._converter.toThreeJsColorInput(materialData.color));
        if (materialData.color === undefined && materialData.map !== undefined && materialData.map.color !== undefined)
            generalProperties.color = new THREE.Color(this._converter.toThreeJsColorInput(materialData.map.color));
        if (materialData.color === undefined && materialData.map !== undefined && materialData.map.color === undefined && !(materialSettings !== undefined && materialSettings.useVertexColors))
            generalProperties.color = new THREE.Color(this._converter.toThreeJsColorInput(this._defaultColor));
        if ((materialSettings !== undefined && materialSettings.useVertexColors) && (materialData.color === this._defaultColor || materialData.color === this._defaultColor + 'ff' || materialData.color === undefined))
            generalProperties.color = new THREE.Color('#d3d3d3');
        if (materialData.side !== undefined)
            generalProperties.side = materialData.side === viewer_shared_types_1.MATERIAL_SIDE.BACK ? THREE.BackSide : materialData.side === viewer_shared_types_1.MATERIAL_SIDE.FRONT ? THREE.FrontSide : THREE.DoubleSide;
        /**
         * First exit, lines ans points
         */
        if (type === MATERIAL_TYPE.POINT) {
            generalProperties.size = this._pointSize;
            return { properties: generalProperties, mapCount };
        }
        else if (type === MATERIAL_TYPE.LINE) {
            return { properties: generalProperties, mapCount };
        }
        /**
         * We know evaluate properties that can be applied to basic mesh materials (and the ones extending from them)
         */
        const basicProperties = generalProperties;
        if (materialData.alphaMap !== undefined) {
            basicProperties.format = THREE.RGBAFormat;
            basicProperties.alphaMap = this.createTexture(materialData.alphaMap);
            basicProperties.transparent = true;
            basicProperties.depthWrite = false;
            mapCount++;
        }
        if (materialData.aoMap !== undefined) {
            basicProperties.aoMap = this.createTexture(materialData.aoMap);
            mapCount++;
        }
        if (materialData.aoMapIntensity !== undefined) {
            basicProperties.aoMapIntensity = materialData.aoMapIntensity;
        }
        if (materialData.map !== undefined) {
            basicProperties.map = this.createTexture(materialData.map);
            basicProperties.map.encoding = this._textureEncoding;
            mapCount++;
        }
        /**
         * Second exit, the unlit material
         */
        if (type === MATERIAL_TYPE.UNLIT) {
            if (materialData.KHR_materials_unlit !== undefined)
                basicProperties.KHR_materials_unlit = materialData.KHR_materials_unlit;
            return { properties: basicProperties, mapCount };
        }
        /**
         * We know evaluate properties that can be applied to MeshStandardMaterials and SpecularGlossinessMaterials
         */
        const standardProperties = basicProperties;
        if (materialData.shading !== undefined)
            standardProperties.flatShading = materialData.shading !== 'smooth';
        if (materialData.bumpMap !== undefined) {
            standardProperties.bumpMap = this.createTexture(materialData.bumpMap);
            mapCount++;
        }
        standardProperties.bumpScale = materialData.bumpScale;
        if (materialData.emissiveness !== undefined)
            standardProperties.emissive = new THREE.Color(this._converter.toThreeJsColorInput(materialData.emissiveness));
        if (materialData.emissiveMap !== undefined) {
            standardProperties.emissiveMap = this.createTexture(materialData.emissiveMap);
            standardProperties.emissiveMap.encoding = this._textureEncoding;
            mapCount++;
        }
        standardProperties.envMap = this._envMap;
        if (materialData.normalMap !== undefined) {
            standardProperties.normalMap = this.createTexture(materialData.normalMap);
            mapCount++;
        }
        if (materialData.normalScale !== undefined)
            standardProperties.normalScale = new THREE.Vector2(materialData.normalScale, -materialData.normalScale);
        /**
         * Separation between the two for metalness/roughness and specular/glossiness workflow
         */
        if (type === MATERIAL_TYPE.METALNESS_ROUGHNESS) {
            const meshStandardProperties = standardProperties;
            meshStandardProperties.metalness = materialData.metalness;
            meshStandardProperties.roughness = materialData.roughness;
            if (materialData.metalnessRoughnessMap !== undefined) {
                meshStandardProperties.metalnessMap = this.createTexture(materialData.metalnessRoughnessMap);
                meshStandardProperties.roughnessMap = meshStandardProperties.metalnessMap;
                mapCount++;
            }
            else {
                if (materialData.metalnessMap !== undefined) {
                    meshStandardProperties.metalnessMap = this.createTexture(materialData.metalnessMap);
                    mapCount++;
                }
                if (materialData.roughnessMap !== undefined) {
                    meshStandardProperties.roughnessMap = this.createTexture(materialData.roughnessMap);
                    mapCount++;
                }
            }
            return { properties: meshStandardProperties, mapCount };
        }
        else if (type === MATERIAL_TYPE.SPECULAR_GLOSSINESS) {
            const specularGlossinessProperties = standardProperties;
            if (materialData.KHR_materials_pbrSpecularGlossiness !== undefined)
                specularGlossinessProperties.KHR_materials_pbrSpecularGlossiness = materialData.KHR_materials_pbrSpecularGlossiness;
            if (specularGlossinessProperties.KHR_materials_pbrSpecularGlossiness === true) {
                specularGlossinessProperties.specular = materialData.specular;
                specularGlossinessProperties.glossiness = materialData.glossiness;
                if (materialData.specularGlossinessMap !== undefined) {
                    specularGlossinessProperties.specularMap = this.createTexture(materialData.specularGlossinessMap);
                    specularGlossinessProperties.glossinessMap = specularGlossinessProperties.specularMap;
                    mapCount++;
                }
                else {
                    if (materialData.specularMap !== undefined) {
                        specularGlossinessProperties.specularMap = this.createTexture(materialData.specularMap);
                        mapCount++;
                    }
                    if (materialData.glossinessMap !== undefined) {
                        specularGlossinessProperties.glossinessMap = this.createTexture(materialData.glossinessMap);
                        mapCount++;
                    }
                }
            }
            return { properties: specularGlossinessProperties, mapCount };
        }
        // we should never get here
        const error = new viewer_shared_services_1.ShapeDiverViewerDataProcessingError(`MaterialLoader.getMaterialProperties: No proper material properties were found.`);
        throw this._logger.handleError(viewer_shared_services_1.LOGGINGTOPIC.DATA_PROCESSING, `MaterialLoader.getMaterialProperties`, error);
    }
    /**
     * Create a material object with the provided material data.
     *
     * @param material the material data
     * @returns the material object
     */
    load(materialData, materialSettings) {
        // evaluate which type of material properties we are constructing
        let type;
        if (materialSettings && materialSettings.mode === 0) {
            type = MATERIAL_TYPE.POINT;
        }
        else if (materialSettings && (materialSettings.mode === 1 || materialSettings.mode === 2 || materialSettings.mode === 3)) {
            type = MATERIAL_TYPE.LINE;
        }
        else {
            if (materialData && materialData.KHR_materials_unlit) {
                type = MATERIAL_TYPE.UNLIT;
            }
            else if (materialData && materialData.KHR_materials_pbrSpecularGlossiness) {
                type = MATERIAL_TYPE.SPECULAR_GLOSSINESS;
            }
            else {
                type = MATERIAL_TYPE.METALNESS_ROUGHNESS;
            }
        }
        if (materialData && this._materialCache[materialData.id + '_' + materialData.version + '_' + type])
            return this._materialCache[materialData.id + '_' + materialData.version + '_' + type];
        let { properties, mapCount } = this.getMaterialProperties(materialData, type, materialSettings);
        this.maxMapCount = Math.max(this.maxMapCount, mapCount);
        let material;
        if (type === MATERIAL_TYPE.POINT) {
            material = new THREE.PointsMaterial(properties);
        }
        else if (type === MATERIAL_TYPE.LINE) {
            material = new THREE.LineBasicMaterial(properties);
        }
        else if (type === MATERIAL_TYPE.UNLIT) {
            material = new THREE.MeshBasicMaterial(properties);
        }
        else {
            if (type === MATERIAL_TYPE.SPECULAR_GLOSSINESS) {
                material = new SpecularGlossinessMaterial_1.SpecularGlossinessMaterial(properties);
            }
            else {
                material = new THREE.MeshStandardMaterial(properties);
            }
            const before = material.onBeforeCompile;
            material.onBeforeCompile = (shader, renderer) => {
                before(shader, renderer);
                shader.uniforms.lightSizeUV = { value: this._lightSizeUV };
                shader.uniforms.blending = { value: this._blending };
                material.userData.shader = shader;
            };
            material.defines['ENVMAP_TYPE_' + this._envMapType.toUpperCase()] = '';
            if (materialSettings && materialSettings.useVertexTangents && material.normalScale)
                material.normalScale.y *= -1;
            if (materialSettings && materialSettings.useFlatShading)
                material.flatShading = true;
        }
        if (materialSettings && materialSettings.useVertexColors)
            material.vertexColors = true;
        if (materialData) {
            material.userData = {
                SDid: materialData.id,
                SDversion: materialData.version
            };
        }
        if (materialData && this._materialCache[materialData.id + '_' + materialData.version + '_' + type]) {
            this._materialCache[materialData.id + '_' + materialData.version + '_' + type].copy(material);
            return this._materialCache[materialData.id + '_' + materialData.version + '_' + type];
        }
        material.needsUpdate = true;
        if (materialData)
            this._materialCache[materialData.id + '_' + materialData.version + '_' + type] = material;
        return material;
    }
    updateMaterials() {
        for (let m in this._materialCache)
            this._materialCache[m].needsUpdate = true;
    }
    updateSoftShadow(lightSizeUV, blending) {
        this._lightSizeUV = lightSizeUV;
        this._blending = blending;
        for (let m in this._materialCache) {
            if (this._materialCache[m].userData.shader) {
                this._materialCache[m].userData.shader.uniforms.lightSizeUV.value = lightSizeUV;
                this._materialCache[m].userData.shader.uniforms.blending.value = blending;
            }
        }
    }
    // #endregion Public Methods (7)
    // #region Private Methods (1)
    createTexture(map) {
        const texture = new THREE.Texture(map.image);
        texture.format = THREE.RGBAFormat;
        texture.minFilter = (() => {
            switch (map.minFilter) {
                case viewer_shared_types_1.TEXTURE_FILTERING.NEAREST:
                    return THREE.NearestFilter;
                case viewer_shared_types_1.TEXTURE_FILTERING.NEAREST_MIPMAP_NEAREST:
                    return THREE.NearestMipMapNearestFilter;
                case viewer_shared_types_1.TEXTURE_FILTERING.LINEAR_MIPMAP_NEAREST:
                    return THREE.LinearMipMapNearestFilter;
                case viewer_shared_types_1.TEXTURE_FILTERING.NEAREST_MIPMAP_LINEAR:
                    return THREE.NearestMipMapLinearFilter;
                case viewer_shared_types_1.TEXTURE_FILTERING.LINEAR:
                    return THREE.LinearFilter;
                case viewer_shared_types_1.TEXTURE_FILTERING.LINEAR_MIPMAP_LINEAR:
                default:
                    return THREE.LinearMipMapLinearFilter;
            }
        })();
        texture.magFilter = (() => {
            switch (map.magFilter) {
                case viewer_shared_types_1.TEXTURE_FILTERING.NEAREST:
                    return THREE.NearestFilter;
                case viewer_shared_types_1.TEXTURE_FILTERING.LINEAR:
                default:
                    return THREE.LinearFilter;
            }
        })();
        texture.wrapS = (() => {
            switch (map.wrapS) {
                case viewer_shared_types_1.TEXTURE_WRAPPING.CLAMP_TO_EDGE:
                    return THREE.ClampToEdgeWrapping;
                case viewer_shared_types_1.TEXTURE_WRAPPING.MIRRORED_REPEAT:
                    return THREE.MirroredRepeatWrapping;
                case viewer_shared_types_1.TEXTURE_WRAPPING.REPEAT:
                default:
                    return THREE.RepeatWrapping;
            }
        })();
        texture.wrapT = (() => {
            switch (map.wrapT) {
                case viewer_shared_types_1.TEXTURE_WRAPPING.CLAMP_TO_EDGE:
                    return THREE.ClampToEdgeWrapping;
                case viewer_shared_types_1.TEXTURE_WRAPPING.MIRRORED_REPEAT:
                    return THREE.MirroredRepeatWrapping;
                case viewer_shared_types_1.TEXTURE_WRAPPING.REPEAT:
                default:
                    return THREE.RepeatWrapping;
            }
        })();
        texture.center = new THREE.Vector2(map.center[0], map.center[1]);
        texture.offset = new THREE.Vector2(map.offset[0], map.offset[1]);
        texture.repeat = new THREE.Vector2(map.repeat[0], map.repeat[1]);
        texture.rotation = map.rotation;
        texture.flipY = map.flipY;
        texture.needsUpdate = true;
        return texture;
    }
    get maxMapCount() {
        return this._maxMapCount;
    }
    set maxMapCount(value) {
        this._maxMapCount = value;
    }
    get textureEncoding() {
        return this._textureEncoding;
    }
    set textureEncoding(value) {
        this._textureEncoding = value;
        this.assignTextureEncoding();
    }
}
exports.MaterialLoader = MaterialLoader;
//# sourceMappingURL=MaterialLoader.js.map